<template>
  <div v-if="showLoading" class="fixed inset-0 bg-white z-max-1">
    <AnimationSpinningLoader class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" color="#000"/>
  </div>
  <FormButton v-else @click="toggleOpen" bold color="red"
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
    Unknown Error - Try Again →
  </FormButton>
</template>

<script setup>
import AnimationSpinningLoader from "./AnimationSpinningLoader.vue";
import FormButton from "./FormButton.vue";
import {onMounted, ref} from "vue";

const emits = defineEmits(["toggleOpen"]);
const toggleOpen = emits("toggleOpen");

const showLoading = ref(true);

onMounted(() => {
  setTimeout(() => {
    showLoading.value = false;
  }, 2500);
});
</script>
